export enum DSPMessages {
  MY_ACCOUNT_SESSION_ACTIVE = 'DSP Session Active',
  MY_ACCOUNT_BIND_CONFIRMATION = 'DSP Bind Confirmation'
}
